export default __webpack_public_path__ + "static/media/rocket_anim_38.6e044c4a.png";